import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import excelService from "../services/excelService";

export const analyzeExcel = createAsyncThunk(
  "excelImport/analyzeExcel",
  async (payload, thunkAPI) => {
    try {
      return await excelService.analyzeExcel(payload);
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message || error.message,
      );
    }
  },
);

export const importExcel = createAsyncThunk(
  "excelImport/importExcel",
  async (payload, thunkAPI) => {
    try {
      return await excelService.importExcel(payload);
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message || error.message,
      );
    }
  },
);

const initialState = {
  analyzeResult: null,
  importResult: null,

  isAnalyzing: false,
  isImporting: false,

  error: null,
};

const excelSlice = createSlice({
  name: "excelImport",

  initialState,

  reducers: {
    resetExcelImport: () => initialState,

    clearExcelImportError: (state) => {
      state.error = null;
    },

    clearImportResult: (state) => {
      state.importResult = null;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(analyzeExcel.pending, (state) => {
        state.isAnalyzing = true;
        state.error = null;
        state.analyzeResult = null;
        state.importResult = null;
      })

      .addCase(analyzeExcel.fulfilled, (state, action) => {
        state.isAnalyzing = false;
        state.analyzeResult = action.payload?.data || null;
      })

      .addCase(analyzeExcel.rejected, (state, action) => {
        state.isAnalyzing = false;
        state.error = action.payload || "Excel analyse mislukt.";
      })

      .addCase(importExcel.pending, (state) => {
        state.isImporting = true;
        state.error = null;
      })

      .addCase(importExcel.fulfilled, (state, action) => {
        state.isImporting = false;
        state.importResult = action.payload?.data || null;
      })

      .addCase(importExcel.rejected, (state, action) => {
        state.isImporting = false;
        state.error = action.payload || "Excel import mislukt.";
      });
  },
});

export const { resetExcelImport, clearExcelImportError, clearImportResult } =
  excelSlice.actions;

export default excelSlice.reducer;
